// DatabaseIdModel.ts
import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
export interface IDatabaseIdModel
{
    idType: DatabaseIdTypes,
    id: number | string
}

export class DatabaseId implements IDatabaseIdModel
{
    constructor(id: string | number, idType: DatabaseIdTypes)
    {
        this.id = id;
        this.idType = idType;
    }
    idType: DatabaseIdTypes;
    id: string | number;
}